'use client'

import { motion } from 'framer-motion'
import { contact, heroImage } from '@/lib/site-config'
import { ArrowIcon, PhoneIcon } from '../Icons'

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15, delayChildren: 0.1 } },
}

const item = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
}

export function Hero(): React.ReactElement {
  return (
    <section id="home" className="relative flex min-h-[100svh] items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="مشروع بناء حديث"
          className="h-full w-full object-cover"
          loading="eager"
        />
        {/* Dark overlays */}
        <div className="absolute inset-0 bg-gradient-to-l from-charcoal-950/95 via-charcoal-950/80 to-charcoal-950/60" />
        <div className="absolute inset-0 bg-charcoal-950/55" />
        <div className="absolute inset-0 grid-overlay opacity-60" />
      </div>

      {/* Content */}
      <div className="container-x relative z-10 pt-28 pb-20">
        <motion.div
          variants={container}
          initial="hidden"
          animate="visible"
          className="max-w-3xl"
        >
          <motion.span variants={item} className="eyebrow mb-6">
            <span className="h-1.5 w-1.5 rounded-full bg-gold-400" />
            مقاولات • بناء • تشطيب • ترميم
          </motion.span>

          <motion.h1
            variants={item}
            className="font-heading text-4xl font-extrabold leading-[1.15] text-white sm:text-5xl md:text-6xl lg:text-7xl"
          >
            أبو صالح النييفي
            <br />
            <span className="gold-text">للمقاولات</span>
          </motion.h1>

          <motion.p
            variants={item}
            className="mt-6 font-heading text-2xl font-bold text-gold-200 sm:text-3xl"
          >
            {contact.slogan}
          </motion.p>

          <motion.p
            variants={item}
            className="mt-5 max-w-2xl text-lg leading-relaxed text-charcoal-200"
          >
            حلول عملية في البناء والتشطيب والترميم، مع اهتمام بجودة التنفيذ ودقة التفاصيل
            والالتزام بما يتم الاتفاق عليه مع العميل.
          </motion.p>

          <motion.div variants={item} className="mt-9 flex flex-wrap gap-4">
            <a href="#quote" className="btn-gold">
              اطلب عرض سعر
              <ArrowIcon className="h-5 w-5" />
            </a>
            <a href="#contact" className="btn-outline">
              <PhoneIcon className="h-5 w-5" />
              تواصل معنا
            </a>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2"
      >
        <div className="flex h-10 w-6 items-start justify-center rounded-full border-2 border-gold-400/50 p-1.5">
          <motion.span
            animate={{ y: [0, 8, 0] }}
            transition={{ repeat: Infinity, duration: 1.6 }}
            className="h-2 w-1 rounded-full bg-gold-400"
          />
        </div>
      </motion.div>
    </section>
  )
}
